// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfExcludedBlock_wrapper--WBs","image":"SelfExcludedBlock_image--smz","text":"SelfExcludedBlock_text--XNE"};